
<template>
  <!--采集系统-->
  <div class="collect-system">
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="csId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
      <template slot="opt_systemMark" slot-scope="{row}">
        <a-tooltip>
          <template slot="title">{{row.systemMark}}</template>
          <div class="over-text-width">{{row.systemMark}}</div>
        </a-tooltip>
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <a-row v-if="row.status !== null" type="flex" align="middle" style="width: 50px">
          <a-col :class="[row.status === 1 ? 'success-bg' : 'danger-bg', 'circle-dot']"></a-col>
          <a-col>{{row.status === 1 ? '成功' : '失败'}}</a-col>
        </a-row>
      </template>

      <template slot="opt_regTime" slot-scope="{row}">
<!--        <a-button type="link" @click="showRegLog(row)">{{row.regTime}}</a-button>-->
        <span>{{row.regTime}}</span>
      </template>
    </x-tabula>

    <!--添加采集系统-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @cancel="visible=false"
      v-bind="$store.state.modalConfig"
      :width="700"
      :footer="null"
    >
      <x-addEdit
        ref="addEdit"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      >
      </x-addEdit>
    </a-modal>

  <!--注册时间log的弹窗-->
  <a-modal
    title="查看历史注册时间"
    :visible="regLogVisible"
    @cancel="regLogVisible=false"
    :width="600"
    :footer="null"
    v-bind="$store.state.modalConfig"
  >
    <x-tabula
      rowKey="regId"
      :searchParams="regLogParams"
      :columns="regLogColumns"
      :listApi="regLogApi"
      :rowSelection="false"
    />
  </a-modal>
  </div>
</template>

<script>
import addCollect from './addCollect';
import { fetchSelect } from '@/utils/mixins';
import { empty } from 'ant-design-vue-admin-x';
export default {
  name: 'collectSystem',
  mixins: [addCollect, fetchSelect],
  data () {
    const statusList = [
      { value: 1, label: '成功' },
      { value: 0, label: '失败' }
    ];
    return {
      detailData: {},
      cityList: [],

      regLogVisible: false,
      regLogParams: { csId: undefined },
      regLogApi: {
        url: '/coll/system/regLog',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      regLogColumns: [
        { title: '状态', dataIndex: 'statusDesc', align: '', width: '' },
        { title: '注册时间', dataIndex: 'regTime', align: '', width: '' }
      ],

      searchList: [
        { props: ['areas'], placeholder: '城市', options: [], inputType: 'cascader' },
        { props: ['communityId'], placeholder: '所属小区', options: [], inputType: 'select' },
        { props: ['systemName'], placeholder: '智慧安防小区系统名称', options: [], inputType: 'input' },
        { props: ['systemMark'], placeholder: '智慧安防小区系统标识', options: [], inputType: 'input' },
        { props: ['csAccount'], placeholder: '账号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: statusList, inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', handle: this.openModal, permi: ['community:collectSystem:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:collectSystem:delete'] }
      ],
      rowOptList: [
        {
          text: '修改',
          handle: this.editCollect,
          permi: ['community:collectSystem:edit']
        },
        {
          text: '删除',
          handle: row => this.$refs.table.showDeleteConfirm(row),
          permi: ['community:collectSystem:delete']
        }
      ],
      columns: [
        { title: '城市', dataIndex: 'cityName', align: '', width: '' },
        { title: '所属小区', dataIndex: 'communityName', align: '', width: '' },
        { title: '智慧安防小区系统名称', dataIndex: 'systemName', align: '', width: '' },
        { title: '智慧安防小区系统标识', dataIndex: 'systemMark', align: '', width: '', scopedSlots: {customRender: 'systemMark'} },
        { title: '账号', dataIndex: 'csAccount', align: '', width: '' },
        { title: '状态', dataIndex: 'status', align: '', width: '', scopedSlots: {customRender: 'status'} },
        { title: '注册时间', dataIndex: 'regTime', align: '', width: 175, scopedSlots: {customRender: 'regTime'} },
        { title: '操作', dataIndex: 'action', align: '', width: 100, scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        areas: undefined,
        communityId: undefined,
        systemName: undefined,
        systemMark: undefined,
        csAccount: undefined,
        status: undefined
      },
      listApi: {
        url: '/coll/system/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '/coll/system/delete/',
        title: '采集系统',
        key: 'systemName',
        resHandle: this.delResHandle // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.provinceCitySelect(data => {
        this.searchList[0].options = data;
        this.cityList = data;
      });

      this.getCommunitySelect(undefined, 1);
    },
    /** 获取小区下拉 */
    getCommunitySelect (id, index) {
      this.$get({
        url: '/coll/system/getCommunity',
        params: { cityId: id }
      }).then(({ data }) => {
        this.searchList[index].options = data;
      });
    },
    /** 删除完成的处理 */
    delResHandle () {
      this.getCommunitySelect(undefined, 1);
    },
    /** 查看注册日志 */
    showRegLog (row) {
      this.regLogParams.csId = row.csId;
      this.regLogVisible = true;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss">
@import "../../../style/variable";
</style>
